<template>
  <div class="row clearfix">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <!-- <div class="header">
                            <h2><strong>Input</strong> <small>Different sizes and widths</small> </h2>                        
                        </div> -->

        <div class="body">
          <h2 class="card-inside-title">키 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="key"
                  placeholder="키 등록"
                />
              </div>
            </div>
          </div>
          <h2 class="card-inside-title">이름 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="name"
                  placeholder="이름 등록"
                />
              </div>
            </div>
          </div>
          <h2 class="card-inside-title">단어 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="noun"
                  placeholder="한 단어로 쓰기"
                />
              </div>
            </div>
          </div>
          <h2 class="card-inside-title">설명 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <textarea
                id="helpText"
                placeholder=""
                v-model="description"
                style="width: 100%; height: 80px"
              ></textarea>
            </div>
          </div>
          <!-- <h2 class="card-inside-title">방향 (선택)</h2>
                            <div class="row clearfix">
                                    <div class="col-sm-12">
                                        <textarea id="helpText"  placeholder="" style="width: 100%; height: 80px;"></textarea>
                                </div>
                            </div> -->

          <h2 class="card-inside-title">보이기 옵션 (선택)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <select class="form-control show-tick" v-model="visible">
                <option value="Y">중요(유저에게 보임)</option>
                <option value="H">숨김(유저에게 보이지 않음)</option>
<!--                <option value="N">없음</option>-->
              </select>
            </div>
          </div>

          <div style="text-align: right; margin-bottom: 10px; margin-top: 10px">
            <button
              type="button"
              class="btn btn-primary"
              @click="toTriggerInput"
              :disabled="triggerBtn"
            >
              저장
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- #END# Input -->
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

export default {
  methods: {
    toTriggerInput() {
      // if (this.name != null) {
      //   this.name = this.name.replace(/\s/g, "");
      // }

      // if (this.key != null) {
      //   this.key = this.key.replace(/\s/g, "");
      // }

      if (this.key == null || this.key == "") {
        alert("키를 써주세요.");
        return;
      }

      if (this.name == null || this.name == "") {
        alert("이름을 써주세요.");
        return;
      }

      if (this.noun == null || this.noun == "") {
        alert("단어를 써주세요.");
        return;
      }

      if (this.description == null || this.description == "") {
        alert("설명을 써주세요.");
        return;
      }

      this.triggerBtn = true

      var param = {
        appCode: this.$store.state.devStore.appCode,
        versionCode: this.$store.state.devStore.appData.versionCode,
        apiCode: this.$store.state.devStore.apiCode,
        apiType: "trigger",
        apiKey: this.key,
        apiName: this.name,
        noun: this.noun,
        description: this.description,
        visible: this.visible,
        // apiText : this.description,  text에 기타 등등 넣기
      };

      if (this.$store.state.devStore.title == "__new__") {

        this.api.insertApi(param)
          .then((res) => {
            console.log("저장 : ", res);

            this.$store.state.devStore.title = this.name;
            this.$store.state.devStore.apiCode = res.api.apiCode;

            console.log(res.api.apiCode);
            console.log(this.$store.state.devStore.apiCode);

            this.$store.state.devStore.formsData = [];

            this.setDataing();
          })
          .catch(() => alert("오류가 발생했습니다."));
      } else {
        this.api.updateApi(param)
          .then((res) => {
            console.log("저장 : ", res);

            this.setDataing();
          })
          .catch(() => alert("오류가 발생했습니다. auth fields"));
      }
    },

    setDataing() {
      console.log(this.$store.state.devStore.apiCode);
      console.log("데이터 새로 끍어오기");

      // var param =     {
      //       apiCode: this.$store.state.devStore.apiCode,
      // }
      //
      // this.api.selectApiSchema(param)
      //   .then((res) => {
      //
      //     this.$store.state.devStore.apiData = res.api;
      //     this.$store.state.devStore.formsData = res.forms;
      //     this.$store.state.devStore.configureData = res.configs;
      //     this.$store.state.devStore.testData = res.test;
      //     this.$store.state.devStore.defineData = res.defines;
      //
      //
      //     console.log(this.$store.state.devStore.apiData);
      //     console.log(this.$store.state.devStore.formsData);
      //     console.log(this.$store.state.devStore.configureData);
      //
      //     this.triggerBtn = false
      //
      eventbus.$emit("menuReset");
          this.$router.push({
            name: "DevTrigInput",
            params: { appId: this.$route.params.appId },
          });
      //   })
      //   .catch(() => alert("오류가 발생했습니다. > 인증 부분 "));
    },
  },

  data() {
    return {
      key: null,
      name: null,
      noun: null,
      description: null,
      visible: "Y",

      triggerBtn : false,
    };
  },
  mounted() {
    console.log("DevTrigSetting.mounted");
    //    this.$store.dispatch("apiDetail").then(() => {

    //        console.log(this.$store.state.devStore.apiData)

    //         this.key = this.$store.state.devStore.apiData.apiKey.replace(/"/gi, "")
    //         this.name = this.$store.state.devStore.apiData.apiName.replace(/"/gi, "")
    //         this.noun = this.$store.state.devStore.apiData.noun.replace(/"/gi, "")
    //         this.description = this.$store.state.devStore.apiData.description.replace(/"/gi, "")
    //         this.visible = this.$store.state.devStore.apiData.visible.replace(/"/gi, "")

    //     });
  },
  created() {
    console.log("DevTrigSetting.created");
    console.log(this.$store.state.devStore.apiCode);

    eventbus.$on("updateTrigger", () => {

      var param =     {
        apiCode: this.$store.state.devStore.apiCode,
      }


      this.api.selectApiSchema(param)
          .then((res) => {

            this.$store.state.devStore.apiData = res.api;
            this.$store.state.devStore.formsData = res.forms;
            this.$store.state.devStore.configureData = res.configs;
            this.$store.state.devStore.testData = res.test;
            this.$store.state.devStore.defineData = res.defines;


            console.log(this.$store.state.devStore.apiData);
            console.log(this.$store.state.devStore.formsData);
            console.log(this.$store.state.devStore.configureData);

            this.key = this.$store.state.devStore.apiData.apiKey.replace(/"/gi, "");
            this.name = this.$store.state.devStore.apiData.apiName.replace(
                /"/gi,
                ""
            );
            this.noun = this.$store.state.devStore.apiData.noun.replace(/"/gi, "");
            this.description = this.$store.state.devStore.apiData.apiText.replace(
                /"/gi,
                ""
            );
            this.visible = this.$store.state.devStore.apiData.visible.replace(
                /"/gi,
                ""
            );







          })
          .catch(() => alert("오류가 발생했습니다. > 인증 부분 "));







    });

    if (this.$store.state.devStore.title == "__new__") {
      console.log("신규");
    } else {


      var param =     {
        apiCode: this.$store.state.devStore.apiCode,
      }


      this.api.selectApiSchema(param)
          .then((res) => {

            console.log("trig setting :",res)

            this.$store.state.devStore.apiData = res.api;
            this.$store.state.devStore.formsData = res.forms;
            this.$store.state.devStore.configureData = res.configs;
            this.$store.state.devStore.testData = res.test;
            this.$store.state.devStore.defineData = res.defines;


            console.log(this.$store.state.devStore.apiData);
            console.log(this.$store.state.devStore.formsData);
            console.log(this.$store.state.devStore.configureData);

            this.key = this.$store.state.devStore.apiData.apiKey.replace(/"/gi, "");
            this.name = this.$store.state.devStore.apiData.apiName.replace(
                /"/gi,
                ""
            );
            this.noun = this.$store.state.devStore.apiData.noun.replace(/"/gi, "");
            this.description = this.$store.state.devStore.apiData.apiText.replace(
                /"/gi,
                ""
            );
            this.visible = this.$store.state.devStore.apiData.visible.replace(
                /"/gi,
                ""
            );



          })
          .catch(() => alert("오류가 발생했습니다. > 인증 부분 "));


    }
  },
};
</script>
